$shm_hitalama_speech $mol_view
	sub /
		<= Toggle $mol_check_icon
			sub /
				^ enabled_visible / <= Enabled $mol_speck
				<= Toggle_icon
			Icon <= Toggle_icon $mol_icon_microphone
			checked? <=> hearing? false
		<= Picker $shm_hitalama_speech_picker
